// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DomainPathRuleScopeSchema = z.enum(['ALLOWLIST','BLOCKLIST'] as const);

export type DomainPathRuleScopeType = `${z.infer<typeof DomainPathRuleScopeSchema>}`

export default DomainPathRuleScopeSchema;
